import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { mobileVerification } from "../../../redux/auth/actions";
import { Toaster } from "../../../utils/toaster";
import { useDispatch } from "react-redux";
import { APP_CONST, AuthModals } from "../../../config/const";
import useAuthModalHook from "../../../hooks/useAuthModalHook";
// import LoginLeftPart from "../../../assets/images/modal1.png";

export const getMobileDetails = () => {
  const details =
    localStorage.getItem("mobile_details") &&
    JSON.parse(localStorage.getItem("mobile_details"));
  return details || {};
};

const MobileNumberVerifyModal = ({ show }) => {
  const { updateActiveAuthModal } = useAuthModalHook();
  const [isVerifying, setIsVerifying] = useState(false);
  const [otp, setOtpValue] = useState("");
  const dispatch = useDispatch();

  const handleSubmit = () => {
    setIsVerifying(true);

    dispatch(mobileVerification({ ...getMobileDetails(), otp }))
      .then((res) => {
        setIsVerifying(false);
        updateActiveAuthModal(AuthModals.Register);
      })
      .catch((err) => {
        setIsVerifying(false);
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
      });
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-register verify"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => updateActiveAuthModal(null)}
        closeVariant="black"
      ></Modal.Header>
      <Modal.Body>
        <div className="inner-wrapper">
          <h2 className="title">Enter The OTP</h2>

          <Form>
            <Form.Group className="form-group" controlId="formBasicOTP">
              <Form.Control
                type="text"
                placeholder="Enter OTP*"
                onChange={(e) => setOtpValue(e.target.value)}
              />
            </Form.Group>

            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={isVerifying}
              style={{ marginTop: "30px" }}
            >
              {!isVerifying ? "Verify OTP" : "Submitting..."}
            </Button>
          </Form>

          <div className="signin-signup">
            Already have an account?{" "}
            <a
              onClick={() => {
                updateActiveAuthModal(AuthModals.Login);
              }}
            >
              Sign In
            </a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MobileNumberVerifyModal;
